import carrierList from "./CarrierList";

export default carrierList;
